import React, { type FC, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import {
  Title,
  SpacingVertical,
  Text,
  Link,
  LINK_VARIANT_HIGHLIGHT,
} from "mailup-web-components";
import { openHelp } from "Helpers/openHelp";
import { notifyParent } from "mailup-react-helpers";
import { useRecoilCallback, useRecoilValue } from "recoil";
import { previewTableState } from "Pages/ImportWizard/recoil/state/stateStep2";
import { importFileWizardState } from "Pages/ImportWizard/recoil/state/state";
import Field from "./Field";
import { initStep3Callback } from "Pages/ImportWizard/recoil/callbacks";
import { gainsightTrack } from "mailup-react-helpers";

const FieldsAssociation: FC = () => {
  const intl = useIntl();
  const { Rows } = useRecoilValue(previewTableState);
  const { FieldMapping } = useRecoilValue(importFileWizardState);
  const initStep3 = useRecoilCallback(initStep3Callback);

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    gainsightTrack("mup_importWizard_visitThirdStep", {});

    window.scrollTo({ top: 0, behavior: "smooth" });

    initStep3();
  }, []);

  const openGuide = () => {
    gainsightTrack("mup_importWizard_clickOnlineHelpInstepThree", {});

    notifyParent("openHelp", [openHelp("importFileGuide")]);
  };

  return (
    <>
      <Title variant="M">
        {intl.formatMessage({ id: "Load.FileImport.FieldAssociationTitle" })}
      </Title>
      <SpacingVertical variant="8" />
      <Text>
        {Rows[0].length === 1
          ? intl.formatMessage(
              {
                id: "Load.FileImport.FieldAssociationDesctSingolar",
              },
              {
                link: (chunks) => (
                  <Link
                    variant={LINK_VARIANT_HIGHLIGHT}
                    onClick={() => openGuide()}
                  >
                    {chunks}
                  </Link>
                ),
                n: <strong>{Rows[0].length}</strong>,
              },
            )
          : intl.formatMessage(
              { id: "Load.FileImport.FieldAssociationDesct" },
              {
                link: (chunks) => (
                  <Link
                    variant={LINK_VARIANT_HIGHLIGHT}
                    onClick={() => openGuide()}
                  >
                    {chunks}
                  </Link>
                ),
                n: <strong>{Rows[0].length}</strong>,
              },
            )}
      </Text>
      <SpacingVertical />
      {Rows[0].map((r: string, index: number) => (
        // biome-ignore lint/correctness/useJsxKeyInIterable: <explanation>
        <Field value={r} index={index} />
      ))}
    </>
  );
};
export default FieldsAssociation;
